export default [
    {
      path: '/adminpanel',
      name: 'adminpanel',
      component: () => import('@/views/sft/AdminPanel.vue'),
      meta: { requiresAdmin: true }
    },
  ]